"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CustomLegend = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("./styles");
var _Text = _interopRequireDefault(require("../../../core/Text"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const CustomLegend = props => {
  const {
    margin
  } = props;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.LegendsContainer, {
    margin: margin && margin,
    columns: props?.payload?.length,
    children: props?.payload?.length && props.payload.map(legend => /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.LegendWrapper, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
        width: "16",
        height: "16",
        children: [legend.type === 'rect' && /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
          width: "100%",
          height: "100%",
          rx: "3",
          fill: legend.color
        }), legend.type === 'line' && /*#__PURE__*/(0, _jsxRuntime.jsx)("line", {
          x1: "0",
          y1: "8",
          x2: "16",
          y2: "8",
          style: {
            stroke: legend.color,
            strokeWidth: '3px'
          }
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
        children: legend.value
      })]
    }, legend.value))
  });
};
exports.CustomLegend = CustomLegend;